export class ReferralItem {
    person: any
    referralItemId?: string
    createdAt?: Date
    updatedAt?: Date
    personId?: string
    referralId?: string
    contacted?: Date
    replied?: Date
    scheduled?: Date
    attended?: Date
    converted?: Date
    revenue?: number
    relationship: string
    isCustomer?: boolean
}
